






















































import Vue, { PropType } from 'vue'
import { AccountSummary, VideoChannelSummary } from '../../../PeerTube/shared/models'

export default Vue.extend({
  props: {
    actor: Object as PropType<AccountSummary | VideoChannelSummary>,
    type: String
  },

  computed: {
    linkTitle () {
      if (this.type === 'channel') return this.$gettext('Go on this channel page')

      return this.$gettext('Go on this account page')
    }
  }
})
